import { ITrick } from '@Config/tricks';

class Score
{
    /*--------- Scores ----------*/
    private distanceScore: number;
    private tricksScore: number;

    /**
     * Constructor
     */
    constructor()
    {
        this.resetScores();
    }

    /**
     * Reset scores
     */
    public resetScores()
    {
        this.distanceScore = 0;
        this.tricksScore = 0;
    }

    /**
     * Sets distance
     * @param distance
     */
    public setDistanceScore(distanceScore: number)
    {
        if (this.distanceScore < distanceScore)
        {
            this.distanceScore = distanceScore;
        }
    }

    /**
     * Sets trick score
     * @param trickScore
     */
    public setTrickScore(trickScore: number)
    {
        if (this.tricksScore < trickScore)
        {
            this.tricksScore = trickScore;
        }
    }

    /**
    * Adds and tallies up tricks to the score
    */
    public addTricksToScore(tricks: ITrick[])
    {
        for (let trick of tricks)
        {
            this.tricksScore += trick.value;
        }
    }

    /**
     * Returns trick score
     */
    public getTrickScore(): number
    {
        return this.tricksScore;
    }

    /**
     * Returns distance
     */
    public getDistanceScore(): number
    {
        return this.distanceScore;
    }

    /**
     * Returns total score
     */
    public getTotalScore(): number
    {
        return this.distanceScore + this.tricksScore;
    }

}

export default Score;